import React, { useState } from "react";
import clsx from "clsx";
import SearchImage from "../images/Search.png";
import DexterIcon from "../../MerchantLoanRequests/icons/dexter-pink.svg";
import ZoomableImage from "../../Shared/ZoomedImage/ZoomableImage";

const RequestImages = ({ imageTabs, loading = false, error = false }) => {
  const [activeTab, setActiveTab] = useState("bank_inclusion_form");

  const currentTab = imageTabs.find((tab) => tab.value === activeTab);

  if (loading) {
    return (
      <div className="request-images-section">
        <div className="image-tabs-container">
          <div className="image-tabs">
            {imageTabs.map((tab) => (
              <div
                key={tab.value}
                className="skeleton skeleton-text skeleton-text--large"
              ></div>
            ))}
          </div>
          <div className="image-tabs-icon-container">
            <img
              src={DexterIcon}
              alt="DexterIcon"
              className="image-tabs-icon"
            />
          </div>
        </div>
        <div className="image-grid">
          <div className="skeleton skeleton-image"></div>
          <div className="skeleton skeleton-image"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-state">
        <img src={SearchImage} alt="Error" className="error-image" />
        <h4 className="error-title">Error Fetching Images</h4>
        <p className="error-message">Please try again.</p>
      </div>
    );
  }

  return (
    <div className="request-images-section">
      <div className="image-tabs-container">
        <div className="image-tabs">
          {imageTabs.map((tab) => (
            <button
              key={tab.value}
              className={clsx("image-tab", { active: activeTab === tab.value })}
              onClick={() => setActiveTab(tab.value)}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="image-tabs-icon-container">
          <img src={DexterIcon} alt="DexterIcon" className="image-tabs-icon" />
        </div>
      </div>
      <div className="image-grid">
        {currentTab?.images.map((image, index) => (
          <ZoomableImage
            key={`${activeTab}-${index}`}
            src={image.src}
            alt={image.label}
            label={image.label}
            initialRotation={image.rotate || 0}
            showRotateButton={false}
            canRotate={true}
            errorImage={SearchImage}
            errorText="No image found"
            className="request-image"
            containerClassName="image-item"
          />
        ))}
      </div>
    </div>
  );
};

export default RequestImages;
